import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/templates/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/o/$orgId/c/$clientId/templates/library',
      params: { orgId: params.orgId, clientId: params.clientId },
    });
  },
});
